import { Box, Button, ButtonGroup, Divider, Typography } from "@mui/material";
import React from "react";
import theme from "../../theme/theme";
import SharedButton from "../Shared/SharedButton";

const MeetingActions = ({
  ownMeeting,
  myStatus,
  iRequestedReschedule,
  acceptDeclineMeetingHandler,
  askForRescheduleHandler,
  rescheduleMeetingHandler,
  cancelMeetingHandler,
  disabledButton,
  closeMeetingModalHandler,
}) => {
  const isOwner = ownMeeting();
  // The invitee already responded (accepted / declined) — show a status
  // message instead of the action buttons, so they can't e.g. accept again.
  const responded = !isOwner && myStatus && myStatus !== "pending";
  // The invitee already proposed a reschedule that's awaiting the owner.
  const awaitingReschedule =
    !isOwner && myStatus === "pending" && iRequestedReschedule;

  const statusText = () => {
    if (responded) {
      return myStatus === "accepted"
        ? "You have accepted this meeting"
        : "You have declined this meeting";
    }
    return "You requested a reschedule — awaiting the organizer's response";
  };

  const statusColor = () => {
    if (myStatus === "accepted") return theme.palette.success.main;
    if (myStatus === "declined") return theme.palette.error.main;
    return theme.palette.warning.main;
  };

  return (
    <Box
      sx={{
        borderTop: `1px solid ${theme.palette.primary.main}`,
        paddingTop: "1rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 1,
      }}
    >
      {(responded || awaitingReschedule) && (
        <Typography
          sx={{
            color: statusColor(),
            fontWeight: 600,
            fontSize: 14,
            marginRight: "auto",
          }}
        >
          {statusText()}
        </Typography>
      )}

      <Button
        variant="outlined"
        color="primary"
        onClick={() => closeMeetingModalHandler()}
        sx={{
          borderRadius: "6px !important",
          border: "1px solid #77a9da !important",
          color: "#77a9da",
        }}
      >
        Cancel
      </Button>

      {isOwner ? (
        <>
          {cancelMeetingHandler && (
            <Button
              variant="outlined"
              color="error"
              onClick={cancelMeetingHandler}
              disabled={disabledButton()}
              sx={{ textTransform: "none" }}
            >
              Cancel Meeting
            </Button>
          )}
          <SharedButton
            color="primary"
            text="Edit"
            onAction={rescheduleMeetingHandler}
            disabled={disabledButton()}
          />
        </>
      ) : responded ? (
        // Already accepted → let the invitee withdraw (revert to declined)
        // while the meeting is still active. A declined response stays final.
        myStatus === "accepted" ? (
          <Button
            variant="outlined"
            color="error"
            onClick={() => acceptDeclineMeetingHandler("declined")}
            disabled={disabledButton()}
            sx={{ textTransform: "none" }}
          >
            Cancel my acceptance
          </Button>
        ) : null
      ) : awaitingReschedule ? null : (
        <ButtonGroup
          variant="contained"
          aria-label="meeting actions"
          sx={{
            display: "flex",
            alignItems: "center",
            boxShadow: "none",
          }}
        >
          <SharedButton
            color="error"
            text="Decline"
            onAction={() => acceptDeclineMeetingHandler("declined")}
            disabled={disabledButton()}
          />
          <Divider orientation="vertical" flexItem />

          <SharedButton
            color="primary"
            text="Ask for reschedule"
            onAction={askForRescheduleHandler}
            disabled={disabledButton()}
          />
          <Divider orientation="vertical" flexItem />

          <SharedButton
            color="primary"
            text="Accept"
            onAction={() => acceptDeclineMeetingHandler("accepted")}
            disabled={disabledButton()}
          />
        </ButtonGroup>
      )}
    </Box>
  );
};

export default MeetingActions;
